import React, { Component, useContext, useEffect, useState } from "react";
import "./App.css";
import { ModalStyles } from "./styles";
import RoadmapCreator from "./components/roadmapCreator/RoadmapCreator.jsx";
import Dashboard from "./components/dashboard/Dashboard.jsx";
import {
  Modal,
  EmailConfirmer,
  PasswordResetter,
  Navbar,
  HomeView,
  RoadmapReader,
} from "./components";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { StitchAuthProvider, useStitchAuth } from "./StitchAuth";
import { app } from "./stitch";

export const AppStitchAuthParser = ({ children }) => {
  return (
    <StitchAuthProvider>
      <App />
    </StitchAuthProvider>
  );
};

export default function App() {
  const [isModalShowing, setIsModalShowing] = useState(false);

  const toggleModalFn = () => {
    setIsModalShowing(!isModalShowing);
  };

  const { isLoggedIn, actions } = useStitchAuth();
  useEffect(() => {
    /*
    if (!isLoggedIn) {
      actions.handleEmailLogin({
        email: "test@gmail.com",
        password: "test@gmail.com",
      });
    }
    */
  }, []);

  return (
    <RequiredAnonLogin>
      <ModalContext.Provider
        value={{
          isModalShowing: isModalShowing,
          toggleModal: toggleModalFn,
        }}
      >
        <MainContainer isModalShowing={isModalShowing}>
          <Router>
            <Route exact path={["/"]} component={Navbar} />
            <Switch>
              <Route path="/confirmEmail" component={EmailConfirmer} />
              <Route path="/resetPassword" component={PasswordResetter} />
              <PrivateRoute path="/create" component={RoadmapCreator} />
              <Route path="/roadmap/:id" component={RoadmapReader} />
              <PrivateRoute path="/dashboard" component={Dashboard} />
              <Route path="/" component={HomeView} />
            </Switch>
            <Modal
              isModalShowing={isModalShowing}
              toggleModal={toggleModalFn}
            />
          </Router>
        </MainContainer>
      </ModalContext.Provider>
    </RequiredAnonLogin>
  );
}

export const ModalContext = React.createContext({
  isModalShowing: false,
  toggleModal: () => {},
});

const MainContainer = (props) => {
  // could use ModalContext consumer for standarized code, but this is faster
  return (
    <div
      className="mainContainer"
      style={{
        background: props.isModalShowing ? "rgba(0, 0, 0, 0.5)" : null,
      }}
    >
      {props.children}
    </div>
  );
};

const RequiredAnonLogin = ({ children }) => {
  const { currentUser } = useStitchAuth();
  console.log({ currentUser });
  return currentUser ? children : <div>logging in annoymously</div>;
};

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { isLoggedIn } = useStitchAuth();
  const { toggleModal } = useContext(ModalContext);

  if (isLoggedIn) {
    return <Route component={Component} />;
  } else {
    toggleModal();
    return <Redirect to={{ pathname: "/" }} />;
  }
};
